import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {BadgesData, RewardsData} from '@/types/loyalty';

type LoyaltyState = {
    badgesData: BadgesData | null;
    rewardsData: RewardsData | null;
};

const initialState: LoyaltyState = {
    badgesData: null,
    rewardsData: null,
};

export const slice = createSlice({
    name: 'loyalty',
    initialState,
    reducers: {
        setBadgesData: (state, action: PayloadAction<BadgesData>) => {
            return {...state, badgesData: action.payload};
        },
        setRewardsData: (state, action: PayloadAction<RewardsData>) => {
            return {...state, rewardsData: action.payload};
        },
    },
});

export const {setBadgesData, setRewardsData} = slice.actions;
export default slice.reducer;
